import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import fakeAuthorData from "./fakeData.js";
import styles from "./autor.module.css";

const AuthorProfile = () => {
    const { id } = useParams();
    const [author, setAuthor] = useState(null);

    // Exemplo de fetch fake ou uso de mock
    useEffect(() => {
        // Buscar ou simular dados
        // ...
        setAuthor(fakeAuthorData);
    }, [id]);

    if (!author) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <h1 className="author-not-found">Autor não encontrado.</h1>
            </div>
        );
    }

    return (
        <div className="container py-5" style={{ marginTop: "82px", minHeight: "60vh", maxWidth: "1150px" }}>
            {/* Card principal */}
            <div className="card author-card " style={{ backgroundColor: "transparent", color: "#fff", padding: "0px", marginBottom: "0px", border: "none" }}>
                <div className="row g-0">
                    <div className="col-md-4 text-center p-4">
                        <img
                            src={author.image || "https://via.placeholder.com/150"}
                            alt={author.name || "Autor Desconhecido"}
                            className="img-fluid rounded-circle shadow-sm mb-3 author-image"
                        />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <h1 className="card-title author-name">
                                {author.name || "Nome não informado"}
                            </h1>
                            <p className="card-text author-biography mb-2">
                                {author.biografia || "Biografia não disponível."}
                            </p>

                            {/* E-mail */}
                            {author.email ? (
                                <a href={`mailto:${author.email}`} className="btn btn-link email-link p-0">
                                    {author.email}
                                </a>
                            ) : (
                                <p className="placeholder-text">E-mail não disponível</p>
                            )}

                            {/* Redes Sociais (apenas ícones) */}
                            <div className="mt-2">
                                <ul className="d-flex align-items-center flex-direction-row gap-2">
                                    <li
                                        className=""
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "#fff",
                                            padding: "0px",
                                            marginBottom: "20px",
                                            border: "none"
                                        }}
                                    >
                                        {author.facebook ? (
                                            <a href={author.facebook} target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-facebook-f" style={{ fontSize: "1.5rem" }}></i>
                                            </a>
                                        ) : (
                                            <i className="uil uil-facebook-f" style={{ fontSize: "1.5rem" }}></i>
                                        )}
                                    </li>

                                    <li
                                        className="list-group-item"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "#fff",
                                            padding: "0px",
                                            marginBottom: "20px",
                                            border: "none"
                                        }}
                                    >
                                        {author.instagram ? (
                                            <a href={author.instagram} target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-instagram" style={{ fontSize: "1.5rem" }}></i>
                                            </a>
                                        ) : (
                                            <i className="uil uil-instagram" style={{ fontSize: "1.5rem" }}></i>
                                        )}
                                    </li>

                                    <li
                                        className="list-group-item"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "#fff",
                                            padding: "0px",
                                            marginBottom: "20px",
                                            border: "none"
                                        }}
                                    >
                                        {author.linkedin ? (
                                            <a href={author.linkedin} target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-linkedin-alt" style={{ fontSize: "1.5rem" }}></i>
                                            </a>
                                        ) : (
                                            <i className="uil uil-linkedin-alt" style={{ fontSize: "1.5rem" }}></i>
                                        )}
                                    </li>

                                    <li
                                        className="list-group-item"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "#fff",
                                            padding: "0px",
                                            marginBottom: "20px",
                                            border: "none"
                                        }}
                                    >
                                        {author.twitter ? (
                                            <a href={author.twitter} target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-twitter" style={{ fontSize: "1.5rem" }}></i>
                                            </a>
                                        ) : (
                                            <i className="uil uil-twitter" style={{ fontSize: "1.5rem" }}></i>
                                        )}
                                    </li>

                                    <li
                                        className="list-group-item"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "#fff",
                                            padding: "0px",
                                            marginBottom: "20px",
                                            border: "none"
                                        }}
                                    >
                                        {author.youtube ? (
                                            <a href={author.youtube} target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-youtube" style={{ fontSize: "1.5rem" }}></i>
                                            </a>
                                        ) : (
                                            <i className="uil uil-youtube" style={{ fontSize: "1.5rem" }}></i>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>



            {/* Livros publicados (exemplo) */}
            <div className="mt-0">
                <h2 className="social-title mb-3">Livros publicados:</h2>
                <ul className="list-group list-group-flush">
                    {/* {author.books?.map((book, index) => (
            <li key={index} className="list-group-item">
              {book}
            </li>
          ))} */}
                    <li className="list-group-item placeholder-text" style={{ backgroundColor: "transparent", color: "#fff", padding: "0px", marginBottom: "20px", border: "none" }}>Nenhum livro cadastrado.</li>
                </ul>
            </div>
        </div>
    );
};

export default AuthorProfile;
